import { Field, Item, getFieldValue, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import { RecordOfFields } from 'models/fields';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';

import styles from './Video.module.scss';

interface VideoFields {
  kalturaId: Field<string>;
  isPlaylist: Field<boolean>;
  kalturaPlayerType: Item;
}

type VideoProps = ComponentProps & {
  fields: VideoFields;
};

const cx = classNames.bind(styles);

const Video = (props: VideoProps): React.JSX.Element => {
  const { className, fields } = props;

  const kalturaCode = fields.kalturaId.value;
  const playerId = 'video_id_' + props.rendering.uid;

  const kalturaPlayerTypeItemField = fields.kalturaPlayerType?.fields as RecordOfFields;
  const kalturaPlayerTypeValue = getFieldValue<string>(kalturaPlayerTypeItemField, 'playerID') || '55870672';
  const kalturaPlayerIsVideo = getFieldValue<boolean>(kalturaPlayerTypeItemField, 'isVideoPlayer');

  const { sitecoreContext } = useSitecoreContext();

  React.useEffect(() => {
    const scriptKaltura = document.createElement('script');
    scriptKaltura.type = 'text/javascript';
    scriptKaltura.async = true;
    scriptKaltura.src =
      'https://cdnapisec.kaltura.com/p/6105852/embedPlaykitJs/uiconf_id/' +
      kalturaPlayerTypeValue +
      '?autoembed=true&targetId=' +
      playerId +
      (props.fields.isPlaylist.value ? '&playlist_id=' : '&entry_id=') +
      kalturaCode;

    // Prevents same script from being added multiple times
    if (!document.querySelector(`script[src="${scriptKaltura.src}"]`)) {
      document.body.appendChild(scriptKaltura);
    }
  }, [kalturaCode, playerId, kalturaPlayerTypeValue, sitecoreContext.pageEditing, props.fields.isPlaylist.value]);

  return (
    <div className={cx('responsive_padding', kalturaPlayerIsVideo ? 'video-padding' : 'audio-padding', className)}>
      <div className={cx('responsive_wrapper', 'video-wrapper')}>
        <div id={playerId} style={{ width: '100%', height: '100%' }}></div>
      </div>
    </div>
  );
};

export default compose<VideoProps>(withValidDatasourceCheck(), withStyles())(Video);
